<template>
  <div class="orgTable" flexContainer>
    <div class="table_org" flex-1 flexContainer>
      <div class="search_line" flexContainer>
        <span class="title_num">待认证用户 {{ user_num }} 个</span>
        <div class="search_a" flexContainer>
          <div class="search_input">
            <el-input v-model="search_val" clearable placeholder="搜索" @clear="getList">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button @click="getList">搜索</el-button>
          </div>
        </div>
      </div>
      <div class="table_line" flex-1>
        <el-table :data="tableData" :height="real_height + 'px'" :width="real_width" :header-cell-style="headerClass"
          :row-class-name="class_name" @sort-change="change_table">
          <el-table-column label="编号" min-width="60">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 + (page - 1) * pageSize }}</span>
            </template>
          </el-table-column>
          <el-table-column label="用户头像" width="90">
            <template slot-scope="scope">
              <div><img class="avater" :src="scope.row.avatar" alt=""></div>
            </template>
          </el-table-column>
          <el-table-column label="担当用户名" width="120">
            <template slot-scope="scope">
              <el-popover ref="nickname" placement="top" width="200" trigger="hover" :content="scope.row.nickname">
                <span slot="reference" class="org_name_show">{{
                  scope.row.nickname
                }}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="注册手机号" width="130">
            <template slot-scope="scope">
              <span>{{ scope.row.mobile }}</span>
            </template>
          </el-table-column>
          <el-table-column label="所属公司" width="150">
            <template slot-scope="scope">
              <el-popover ref="company" placement="top" width="250" trigger="hover" :content="scope.row.company">
                <span slot="reference" class="org_name_show">{{
                  scope.row.company
                }}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="真实姓名" width="100">
            <template slot-scope="scope">
              <el-popover ref="popover" placement="top" width="200" trigger="hover" :content="scope.row.name">
                <span slot="reference" class="org_name_show bold-text">{{
                  scope.row.name
                }}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="证件号码" width="180">
            <template slot-scope="scope">
              <span class="bold-text">{{ scope.row.idCardNum }}</span>
            </template>
          </el-table-column>
          <el-table-column label="证件照" width="100">
            <template slot-scope="scope">
              <span class="show_detail" @click="getImage(scope.row)">点击查看</span>
            </template>
          </el-table-column>
          <el-table-column label="提交认证时间" width="180">
            <template slot-scope="scope">
              <span>{{ formTimestamp(scope.row.createTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="认证IP地址" width="130">
            <template slot-scope="scope">
              <span>{{ scope.row.ip }}</span>
            </template>
          </el-table-column>
          <el-table-column label="IP归属地址" width="450">
            <template slot-scope="scope">
              <el-popover ref="ipRegion" placement="top" width="200" trigger="hover" :content="scope.row.ipRegion">
                <span slot="reference" class="org_name_show">{{
                  scope.row.ipRegion
                }}</span>
              </el-popover>
            </template>
          </el-table-column>
          <!-- <el-table-column label="证件人面像" width="130">
            <template slot-scope="scope">
              <div><img class="avater" :src="scope.row.avater" alt=""></div>
            </template>
          </el-table-column>
          <el-table-column label="证件国徽面" width="130">
            <template slot-scope="scope">
              <div><img class="avater" :src="scope.row.avater" alt=""></div>
            </template>
          </el-table-column>
          <el-table-column label="照片" width="130">
            <template slot-scope="scope">
              <div><img class="avater" :src="scope.row.avater" alt=""></div>
            </template>
          </el-table-column> -->
          <el-table-column label="操作" width="140" fixed="right">
            <template slot-scope="scope">
              <span class="show_detail" style="color:green; margin-right:10px" @click="decision(scope.row, 4)">通过</span>
              <span class="show_detail" style="color:red;" @click="showRejectDialog(scope.row)">驳回</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <detail ref="detail_ref"></detail>
    </div>
    <div class="page_line">
      <div class="page_count_info">
        <span class="page_count_text">每页显示 {{ pageSize }} 条</span>
      </div>
      <el-pagination background layout="prev, pager, next" :current-page.sync="page" :page-size="pageSize"
        @current-change="pageChange" :total="totalPage"></el-pagination>
    </div>
    <!-- <el-dialog title="证件照" :visible.sync="centerDialogVisible" width="800px" center>
      <div class="block">
        <el-carousel trigger="click" height="500px">
          <el-carousel-item v-for="item in imgList" :key="item">
            <img class="image" :src="item" alt="">
          </el-carousel-item>
        </el-carousel>
      </div>
    </el-dialog> -->
    <ImageModal
      :images="imgList"
      :isVisible.sync="isModalVisible"
      :currentIndex.sync="imgIndex"
      :name = indexName
    />
    <!-- 驳回对话框 -->
    <el-dialog
      title="驳回认证"
      :visible.sync="rejectDialogVisible"
      width="500px"
      center
    >
      <div>
        <p style="margin-bottom: 15px;">确定要驳回 <strong>{{ currentUser.name }}</strong> 的认证吗？</p>
        <el-form :model="rejectForm" :rules="rejectRules" ref="rejectForm">
          <el-form-item label="驳回原因" prop="reason">
            <div class="reason-input-container">
              <el-input
                v-model="rejectForm.reason"
                placeholder="请输入驳回原因或从下方快速选择"
                type="textarea"
                :rows="3"
                style="width: 100%; margin-bottom: 10px;"
              ></el-input>
              <div class="reason-options">
                <span class="option-label">快速选择：</span>
                <el-button
                  v-for="item in rejectReasons"
                  :key="item.value"
                  size="mini"
                  type="text"
                  @click="selectReason(item.label)"
                  class="reason-option-btn"
                >
                  {{ item.label }}
                </el-button>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="rejectDialogVisible = false">取 消</el-button>
        <el-button type="danger" @click="confirmReject">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import ImageModal from '../../components/ImageModal.vue';
import { getCertificationList, getSearchCertificationList, getCardImg, setStatus } from "../../api/index"
import app from "../../mixin/index"
import dayjs from "dayjs"

export default {
  mixins: [app],
  components: {
    ImageModal
  },
  data () {
    return {
      page: 1,
      pageSize: 10,
      totalPage: "",
      value_date: "",
      search_val: "",
      start: "",
      end: "",
      sort: 0,
      type: 0,
      org_height: document.documentElement.clientHeight,
      real_height: document.documentElement.clientHeight - 238,
      timer: false,
      user_num: "",
      tableData: [],
      imgList: [],
      imgIndex: 0,
      isModalVisible:false,
      indexName:'',
      rejectDialogVisible: false,
      currentUser: {},
      rejectForm: {
        reason: ""
      },
      rejectRules: {
        reason: [
          { required: true, message: "请选择或输入驳回原因", trigger: "change" },
          { min: 2, message: "驳回原因至少2个字符", trigger: "change" }
        ]
      },
      rejectReasons: [
        { value: "证件无效(过期、有效期不足3个月)", label: "证件无效(过期、有效期不足3个月)" },
        { value: "证件照片模糊", label: "证件照片模糊" },
        { value: "证件非原件", label: "证件非原件" },
        { value: "提交证件与注册人信息不符", label: "提交证件与注册人信息不符" },
        { value: "认证人照片模糊", label: "认证人照片模糊" },
        { value: "上传照片不符合仪表要求", label: "上传照片不符合仪表要求" },
        { value: "上传照片不合格", label: "上传照片不合格" }
      ]
    }
  },

  mounted () {
    this.getList()
  },
  methods: {
    getList () {
      if (this.search_val) {
        let data = {
          status: 3,
          page: this.page,
          size: this.pageSize,
          key: this.search_val,
        }
        getSearchCertificationList(data).then(res => {
          console.log(res)
          this.tableData = res.data.records
          this.totalPage = res.data.total || 0
          this.user_num = res.data.total || 0
          console.log(this.totalPage)
        })
      } else {
        let data = {
          status: 3,
          page: this.page,
          size: this.pageSize,
        }
        getCertificationList(data).then(res => {
          console.log(res)
          this.tableData = res.data.records
          this.totalPage = res.data.total || 0
          this.user_num = res.data.total || 0
          console.log(this.totalPage)
        })
      }
    },
    async getImage (info) {
      console.log(info);
      let list = []
      if (info.pic1) {
        list.push(info.pic1)
      }
      if (info.pic2) {
        list.push(info.pic2)
      }
      if (info.pic) {
        list.push(info.pic)
      }
      this.indexName = info.name;
      await getCardImg(list).then(res => {
        this.imgList = [];
        res.data.forEach(item => {
          this.imgList.push({
            src:item,
            alt:'证件照'
          })
          this.isModalVisible = true
        })
      })
    },
    pageChange () {
      this.getList()
    },
    formTimestamp(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    decision (info, type) {
      let title = ''
      if (type == 4) {
        title = '确认通过认证?'
      } else {
        title = '是否确认驳回?'
      }
      this.$confirm(title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        let data = {
          id: info.userId,
          status: type
        }
        setStatus(data).then(res => {
          if (res.code == 1) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
            this.getList()
          }
        })
      })
    },
    // 显示驳回对话框
    showRejectDialog(user) {
      this.currentUser = user;
      this.rejectForm.reason = "";
      this.rejectDialogVisible = true;
    },
    // 选择驳回原因
    selectReason(reason) {
      // 如果输入框已有内容，在后面添加；如果没有内容，直接设置
      if (this.rejectForm.reason.trim()) {
        // 如果当前内容不是以句号、感叹号或分号结尾，先添加分号
        const lastChar = this.rejectForm.reason.trim().slice(-1);
        if (lastChar !== '。' && lastChar !== '！' && lastChar !== '；' && lastChar !== ';') {
          this.rejectForm.reason += '；';
        }
        this.rejectForm.reason += reason;
      } else {
        this.rejectForm.reason = reason;
      }
    },
    // 确认驳回
    confirmReject() {
      this.$refs.rejectForm.validate((valid) => {
        if (valid) {
          let data = {
            id: this.currentUser.userId,
            status: -1,
            reason: this.rejectForm.reason
          };
          setStatus(data).then((res) => {
            if (res.code == 1) {
              this.$message({
                type: "success",
                message: "驳回成功!",
              });
              this.rejectDialogVisible = false;
              this.getList(); // 刷新列表
            } else {
              this.$message({
                type: "error",
                message: res.msg || "操作失败!",
              });
            }
          }).catch((error) => {
            this.$message({
              type: "error",
              message: "网络错误，请稍后重试!",
            });
          });
        }
      });
    }
  },
}
</script>
<style lang="scss" scoped>
/deep/.colorLine {
  background-color: #fafcff !important;
}

/deep/.popularLine {
  background-color: #fff !important;
}

@include table;

.orgTable {
  position: relative;
}

.avater {
  width: 40px;
  height: 40px;
}

.idImg {
  width: 500px;
  height: 400px;

  img {
    width: 100%;
    height: 100%;
  }
}

.el-carousel-item {
  width: 700px;
  height: 500px;
}

.image {
  width: 700px;
  height: 500px;
}

.bold-text {
  font-weight: bold;
}

.page_line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0 20px 0;
}

.page_count_info {
  text-align: left;
}

.page_count_text {
  color: #666;
  font-size: 14px;
}

.reason-input-container {
  .reason-options {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    
    .option-label {
      font-size: 14px;
      color: #666;
      margin-right: 8px;
    }
    
    .reason-option-btn {
      margin: 0 4px 4px 0;
      padding: 4px 8px;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      background: #f5f7fa;
      color: #606266;
      font-size: 12px;
      transition: all 0.3s;
      
      &:hover {
        background: #409eff;
        color: white;
        border-color: #409eff;
      }
    }
  }
}
</style>